webpackJsonp([258086968929011],{

/***/ 1417:
/***/ (function(module, exports) {

	module.exports = {"data":{"allBlogJson":{"edges":[{"node":{"title":"How to Choose a Stack, Part 5: Java","metaDescription":"Looking for resources as you learn to code? The Code Fellows blog features helpful tutorials, alumni stories, student projects, school news, and more!","slug":"blog/how-to-choose-a-stack-part-5-java","createdAt":"2018-04-26T18:10:41.509Z","blogAuthor":{"fields":{"name":"Steve Geluso","slug":"blog/author/steve-geluso"}},"imageHeader":{"fields":{"file":{"url":"//images.ctfassets.net/k428n7s2pxlu/2VDFL9HNC0wKGcEi6saAGY/4a7022776a2fc3f85b9666c300dc4cee/blog-post-blog-how-to-choose-a-stack-part-5-java.jpg"}}}}}]},"authorJson":{"name":"Steve Geluso","slug":"blog/author/steve-geluso","twitter":null,"linkedIn":null,"website":null,"biography":null,"image":null}},"pathContext":{"slug":"blog/author/steve-geluso"}}

/***/ })

});


// WEBPACK FOOTER //
// path---blog-author-steve-geluso-e4b3477c4611024d50f5.js